import { Fragment, h } from "@stencil/core";
import { ActionTypes, dispatch } from "@/core/stores/searchflight.store";
import { theme } from "@/utils/theme";

export const ModalBox = (props: { message: string; payload: object }) => (
  <Fragment>
    <div class="row">
      <div class="col-8">
        <div class={"modal-container__message"}>{props.message}</div>
        <button
          class="button button-primary"
          style={theme.getPrimaryButtonStyle()}
          onClick={() =>
            dispatch({
              type: ActionTypes.HIDE_MODAL,
              payload: props.payload,
            })
          }
        >
          Close
        </button>
      </div>
    </div>
  </Fragment>
);
